// see approval export in './models' for approval model
export const getPendingApprovalString = (attendees, approvals) => {
    const pendingApprovals = getPendingApprovals(attendees, approvals);
    let pendingApprovalsString = '';
    if (!pendingApprovals.length) return pendingApprovalsString;
    for (const pendingApproval of pendingApprovals) {
        if (!pendingApproval.empNum) continue;
        pendingApprovalsString += pendingApproval.attendee + ',';
    }
    return pendingApprovalsString;
};

export const getPendingApprovals = (attendees, approvals) => {
    if (!approvals.length) return attendees;
    return attendees.filter(attendee => !approvals.find(approval => approval.empNum === attendee.empNum));
}

export const getSortValue = (item) => {
    if (!item.Approvals.length) return 0;
    let sortValue = item.Approvals.filter(a => a.ApprovedBy).length;
    const fullyApproved = item.Status === 'Approved';
    if (fullyApproved) {
        sortValue += 50;
    }
    if (item.IsRejected && !fullyApproved) {
        sortValue += 25;
    }
    return sortValue;
};

export const sortByApprovals = (items) => {
    items = items.sort((a, b) => getSortValue(a) - getSortValue(b));
    return items;
};

export const statusTemplate = (di) => {
    const rejectionTag = `<div class="tag tag--small-x tag--blue">${di.RejectedBy}</div>`;
    const tags = ['<div class="capex-approval-wrapper">'];
    if (di.Status === 'Saved') {
        tags.push('<div class="tag tag--small-x tag--blue">Saved</div>');
        tags.push('</div>');
        return tags.join('\r\n');
    }
    const isFormSubmitted = di.Status === 'Approved' || di.Status === 'Submitted';
    let attendees = di.RequiredAttendees.length !== 5 && isFormSubmitted ? di.Attendees : di.RequiredAttendees;
    for (const attendee of attendees) { // create display tags for approvals
        if (!attendee.empNum) continue;
        const approval = di.Approvals.find((approvals) => approvals.empNum === attendee.empNum);
        const approved = Boolean(approval);
        const tagClass = approved ? 'tag--green' : 'tag--red',
            tagText = approved ? approval.ApprovedBy : attendee.attendee;
        const tag = `<div class="tag tag--small-x ${tagClass}">${tagText}</div>`;
        // only add the tag to display later if the row isn't reject
        // if it is rejected, only display the tag if it's also approved

        if (!di.IsRejected)
            tags.push(tag);
        else if (approval && approval.IsApproved)
            tags.push(tag);
    }
    if (di.IsRejected) { // add rejection tag if needed
        tags.push(rejectionTag);
    }
    tags.push('</div>');
    return tags.join('\r\n'); // return all valid tags for display
};